/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ProvinceDto } from '../models/province-dto';
import { provinceGet } from '../fn/province/province-get';
import { ProvinceGet$Params } from '../fn/province/province-get';

@Injectable({ providedIn: 'root' })
export class ProvinceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `provinceGet()` */
  static readonly ProvinceGetPath = '/v1/Province/Get';

  /**
   * Search provinces,   Permissions [LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the matching provinces on your filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `provinceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  provinceGet$Response(params?: ProvinceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProvinceDto>>> {
    return provinceGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Search provinces,   Permissions [LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the matching provinces on your filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `provinceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  provinceGet(params?: ProvinceGet$Params, context?: HttpContext): Observable<Array<ProvinceDto>> {
    return this.provinceGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProvinceDto>>): Array<ProvinceDto> => r.body)
    );
  }

}
